import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Location } from '@angular/common';
import { BasePage2 } from 'src/app/tools/abstract-classes/base-page2';
import { BaseService } from 'src/app/assabil-kernel/services/base-service';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';
import { ControlTablesService } from 'src/app/assabil-kernel/services/control-tables-service';
import { UserService } from 'src/app/assabil-kernel/services/user-service';
import { Vat } from 'src/app/assabil-kernel/models/entities/control-tables/vat';
import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { VatRequest } from 'src/app/assabil-kernel/models/dtos/control-tables/vat-request';



@Component({
  selector: 'app-vat-list',
  templateUrl: './vat-list.component.html',
  styleUrls: ['./vat-list.component.scss']
})
export class VatListComponent extends BasePage2<Vat> {

    // Filter fields
    // ---------------------------------------------------
    code: string;
    name: string;
    rate : number;
    // ---------------------------------------------------
        
    // ---------------------------------------------------
    vats: Vat[] = [];
    // ---------------------------------------------------
    

    constructor(
        protected toastr            : ToastrService,
        protected controlService        : ControlTablesService,
        protected router            : Router,
        protected baseService       : BaseService,
        protected leanUtilsService  : LeanUtilsService,
        protected location          : Location,
        public userService : UserService) {
        super(toastr, router, baseService, leanUtilsService, location);

        this.entityName = 'vat';
    }


    listFields = [
        { prop: 'vatCode', name: 'Code',  insertOnly : true},
        { prop: 'name', name: 'Name' },
        { prop: 'vatRate', name: 'Taux' },
        { prop: 'rank', name: 'Rang' }
    ]

  
//----------------------------------------------------------------------
getRows(): Vat[] {
    return this.vats;
}
//----------------------------------------------------------------------

//----------------------------------------------------------------------
  new(){
    let entity : Vat = new Vat();
    entity.inserted = true;
    entity.edit = true;
    this.vats.push(entity);
    this.vats = [...this.vats];
}
//----------------------------------------------------------------------

//----------------------------------------------------------------------
saveRow(vat: Vat): Promise<Vat> {
    let request  : VatRequest = new VatRequest(this.controlService.getUserInfo());
    request.vat = vat;
    return this.controlService.save(this.entityName, request);
}
//----------------------------------------------------------------------

  
//----------------------------------------------------------------------
loadData() {
    let request         : BaseRequest = this.controlService.getRequest();
    request.strArg1 = this.code;
    request.strArg2 = this.name;

    this.controlService.getList(this.entityName, request).then(result => {
        this.vats = result;  
    })
}
//----------------------------------------------------------------------
}
